'use client';

import { c as _c } from "react/compiler-runtime";
import { Portal } from '@common/components';
import { usePathname } from 'next/navigation';
import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';
import { SUB_DOMAIN } from '@/constants';
import { SAFE_AREA_BOTTOM_IOS } from '@/modules/wello-app/_hooks/useMountAppData';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { useGlobalStore } from '@/stores/GlobalStore';
import { isAppVersionAtLeast } from '@/utils';
import { DonationBnb } from './_components/DonationBnb';
import { LocalMarketBnb } from './_components/LocalMarketBnb';
import { getFloatingBnbKind } from './constants';
export const FloatingBnbController = () => {
  const $ = _c(13);
  const pathname = usePathname();
  const hideBottomNav = useGlobalStore(_temp);
  const isSafeAreaBottomVersion = useDeviceInfoStore(_temp2);
  let t0;
  if ($[0] !== hideBottomNav || $[1] !== pathname) {
    t0 = hideBottomNav ? null : getFloatingBnbKind(pathname);
    $[0] = hideBottomNav;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const activeBnb = t0;
  const t1 = isSafeAreaBottomVersion ? 10 + SAFE_AREA_BOTTOM_IOS : undefined;
  let t2;
  if ($[3] !== t1) {
    t2 = {
      bottom: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== activeBnb) {
    t3 = activeBnb === "donation" && <DonationBnb isMounted={true} />;
    $[5] = activeBnb;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeBnb) {
    t4 = activeBnb === "localMarket" && <LocalMarketBnb isMounted={true} />;
    $[7] = activeBnb;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <Portal renderTo={getMainWrapperElement}><div className="fixed inset-x-0 bottom-10 z-20 hidden w-full mobile-tablet:block" style={t2}>{t3}{t4}</div></Portal>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp(state) {
  return state.hideBottomNav;
}
function _temp2(state_0) {
  return state_0.subDomain === SUB_DOMAIN.WELLO_APP && state_0.osType === "ios" && !!state_0.appVersion && isAppVersionAtLeast(state_0.appVersion, "3.1.10");
}